import { NgModule } from '@angular/core';
import { Routes, RouterModule, ExtraOptions, PreloadAllModules } from '@angular/router';
import { IndexComponent } from './index/index.component';
import { AuthGuard } from './auth.guard';
import { TicketsComponent } from './tickets/tickets.component';
import { DetailComponent } from './tickets/detail/detail.component';
import {TestComponent} from './test/test.component';

const routes: Routes = [
  {
    path: 'pages',
    loadChildren: () => import('./content/content.module').then((m) => m.ContentModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'extra',
    loadChildren: () => import('./extra/extra.module').then((m) => m.ExtraModule),
    canActivate: [AuthGuard],
  },
  { path: 'tickets', component: TicketsComponent, canActivate: [AuthGuard] },
  { path: 'ticketdetails', component: DetailComponent, canActivate: [AuthGuard] },
  { path: 'test', component: TestComponent },
  { path: '', component: IndexComponent },
  { path: '', redirectTo: '', pathMatch: 'full' },
  { path: '**', redirectTo: '' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules, relativeLinkResolution: 'legacy' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
